module.exports = __webpack_public_path__ + "static/media/IOT.5c89dcc9.jpg";